module.exports = __webpack_public_path__ + "static/media/bg-image-13.a71302fb.jpg";